import { useCallback } from "react";
import { useStore } from "../store";
import { useEventBus, EVENT_BUS_EVENTS } from "./useEventBus";

export const CTA_TRIGGER_ACTION = {
  FEATURE_CARD_CONTENT_CLICK: "feature card content click",
  OPEN_FOLLOW_CONTENT_MODAL: "open follow content modal",
  FEATURE_CARD_CLICK: "feature card click",
};

function useCTA() {
  const { userDetails } = useStore().home || {};
  const eventBus = useEventBus();

  const hasCTA = useCallback(
    (e, userAction) => {
      if (
        userDetails &&
        !userDetails.isSubscriptionActive &&
        !(
          userAction === CTA_TRIGGER_ACTION.OPEN_FOLLOW_CONTENT_MODAL &&
          userDetails.isPersonalized
        )
      ) {
        e.preventDefault();
        eventBus.emit(EVENT_BUS_EVENTS.LAUNCH_CTA, null, {
          type: "generic",
          originator: {
            mfe: "home",
            userAction,
            component: "useCTA hook",
          },
        });

        return true;
      }
      return false;
    },
    [eventBus, userDetails]
  );

  return { hasCTA };
}

export default useCTA;
